import React from 'react';
import { useTranslation } from 'react-i18next';
import './Modal.css';

const Modal = ({ 
    isOpen, 
    onClose, 
    title, 
    children, 
    footer,
    size = 'medium' // small, medium, large
}) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className={`modal-container ${size}`}>
                <div className="modal-header">
                    <h2 className="modal-title">{title}</h2>
                    <button 
                        onClick={onClose} 
                        className="modal-close"
                        type="button"
                        aria-label={t('common:buttons.close')}
                    >
                        ×
                    </button>
                </div>
                
                <div className="modal-body">
                    {children}
                </div>
                
                {footer && (
                    <div className="modal-footer">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;